import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { CheckStampService } from "../services/check-stamp.service";
import { ModalDirective } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { BatchstampService } from "../../../qrcode/batchstamp/batchstamp.service";
import { environment } from "../../../../../../environments/environment";
import { AgencyService } from "../../../qrcode/agencyListing/services/agency.service";
import { EvsAddressService } from "../../../../../common/services/EvsAddress.service";
import { WarningInspection } from "../../../qrcode/warning-overflow/services/warning-inspection";

declare var $: any;

@Component({
  selector: "app-stamp-product-mb",
  templateUrl: "./stamp-product-mb.component.html",
  styleUrls: ["./stamp-product-mb.component.css"],
  providers: [CheckStampService, AgencyService, WarningInspection],
})
export class StampProductMbComponent implements OnInit {
  loading_page = false;
  has_data = true;
  data;
  data_verify;
  code = "123";
  // loại tem : true là nhà sản xuất, fale là nhà được phân phối
  type_stamp: boolean;

  // ==================== lich su phan phoi ================ //
  pageIndexDistribution = 1;
  pageSizeDistribution = 10;
  bodyDistribution;
  data_distribution = [];
  total_distribution = 0;
  // ==================== end  lich su phan phoi ================ //

  // ==================== lich su quet ======================= //
  queryScan;
  pageIndexScan = 1;
  pageSizeScan = 10;
  data_scan = [];
  total_scan = 0;
  // ==================== end lich su quet =================== //

  // ============ tra tem ================= //end
  note_return = "";
  valid_note_return = false;
  // ============  tra tem ================= //

  // ==================== ds canh bao thi truong =========== //
  pageIndexWarning = 1;
  pageSizeWarning = 10;
  queryWarning;
  data_warning = [];
  total_warning = 0;
  // ==================== end ds canh bao thi truong ======== //
  form = this.fb.group({});
  listBatches = [];
  actions = [
    {
      label: "Xác nhận",
      value: 1,
    },
    {
      label: "Phân phối",
      value: 2,
    },
    {
      label: "Trả hàng",
      value: 3,
    },
  ];
  totalBatchPage = 10;
  batchCurrentPage = 1;
  message = "Không tìm thấy thông tin tem";
  has_baohanh = true;
  logsScanGuarantee = [];
  logs_BH = {
    currentPage: 1,
    has_list: [],
  };
  listDistribution = [];
  data_map = [];
  data_map_warning = [];
  lat;
  lng;
  zoom = 15;
  activeTab = 1;
  isDistribution: Boolean = false;
  isList: Boolean = true;
  load_map_distrivution = true;
  @ViewChild("boxStampDistribution") boxStampDistribution;

  @ViewChild("checkWarning") checkWarning: ModalDirective;
  @ViewChild("blockModal") blockModal: ModalDirective;
  @ViewChild("retutn") retutn: ModalDirective;
  // block tem
  note_block: string;
  disable_block = false;
  // end block tem

  // canh bao thi truong
  valid_agency = false;
  warning_count = 0;
  note_warning = "";
  agency_detail;
  body: any;
  disable_warning = false;
  cities = [];
  districts = [];
  validProvinceId = false;
  validDistrict = false;
  address = "";

  // end canh bao thi truong
  after_create_warning = false;
  constructor(
    private fb: FormBuilder,
    private checkStampService: CheckStampService,
    private toastr: ToastrService,
    private batchService: BatchstampService,
    private agencyService: AgencyService,
    public addressService: EvsAddressService,
    private warningInspection: WarningInspection
  ) {}

  ngOnInit() {
    this.isDistribution = false;
    this.isList = true;
    const agency = $("#agency");
    agency.select2({
      placeholder: "Chọn đại lý cảnh báo",
      allowClear: false,
      minimumInputLength: 3,
      ajax: {
        delay: 1000,
        url: `${environment.qrcode_url}/agencies`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Access-Token")}`,
          "Content-Type": "application/json",
        },
        dataType: "json",
        data: function (params) {
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 50,
            };
          }
          return {
            offset: 0,
            limit: 50,
          };
        },
        processResults: function (data) {
          return {
            results: data.data.items.map((item) => {
              return {
                text: item.name,
                id: item.id,
              };
            }),
          };
        },
      },
    });
    const that = this;
    agency.on("select2:open", function () {
      that.valid_agency = false;
    });
    agency.on("select2:close", function () {
      const val = agency.val();
      if (!val) {
        that.valid_agency = true;
        return;
      }
      that
        .getTotalWarning(val)
        .then((res) => {
          if (res.code === 1) {
            that.warning_count = res.data;
            return;
          }
          that.warning_count = 0;
        })
        .catch((err) => {
          that.warning_count = 0;
        });
      that.getDetilAgency(val).then((res) => {
        if (res.code === 1) {
          that.agency_detail = res.data;
        }
      });
    });
    this.getFromArea();
    const cities = $("#citiesProduct");
    cities.select2({ placeholder: "Tỉnh thành", allowClear: false });
    cities.on("select2:select", function (e) {
      $(".select2-selection__rendered").removeAttr("title");
      $("#districtProduct").val(null).trigger("change");
      const id = e.target.value;
      that.getDistrict(id);
    });
    cities.on("select2:open", function () {
      that.validProvinceId = false;
    });
    cities.on("select2:close", function (e) {
      const id = e.target.value;
      if (!id) {
        that.validProvinceId = true;
      }
    });
    const district = $("#districtProduct");
    district.select2({ placeholder: "Quận huyện", allowClear: false });
    district.on("select2:open", function () {
      that.validDistrict = false;
    });
    district.on("select2:close", function (e) {
      const id = e.target.value;
      if (!id) {
        that.validDistrict = true;
      }
    });

    $("#note_return2").on("change keyup paste", function () {
      that.valid_note_return = false;
      if (!this.value) {
        that.valid_note_return = true;
      }
    });
  }

  loadData(data) {
    this.data_map = [];
    this.data_map_warning = [];
    this.has_data = true;
    this.after_create_warning = false;
    // owner = true: sản xuất, = false : phân phối
    this.type_stamp = data.owner;
    this.data = data;
    let serial = this.data.serial;
    serial = serial.split("-");
    const id = serial[serial.length - 1];
    const format = "000000";
    // this.data.serial =
    //   serial[0] +
    //   "-" +
    //   format.substring(0, format.length - id.toString().length) +
    //   id;

    serial[serial.length - 1] =
      format.substring(0, format.length - id.toString().length) + id;
    console.log(serial);

    this.data.serial = serial.join("-");
    const idStart = this.data.idStart;
    this.data.idStart =
      format.substring(0, format.length - idStart.toString().length) + idStart;
    console.log(this.data);
    const list = [];
    if (this.data) {
      this.checkStampService.getValidator(this.data.serial).subscribe(
        (res) => {
          this.data_verify = undefined;
          if (res.code === 1) {
            this.data_verify = res.data;
            return;
          }
        },
        (error) => {
          this.data_verify = undefined;
        }
      );
      const services = this.data.service;
      if (services) {
        if (services.includes("CG")) {
          list.push("Chống giả");
        }
        if (services.includes("BH")) {
          list.push("Bảo hành");
        }
        if (services.includes("TH")) {
          list.push("Tràn hàng");
        }
      }
      this.loadHistoryDistribution();
      this.loadHistoryScan();
      this.loadListWarning();
      setTimeout(() => {
        this.getAllWarningMarket();
      }, 2000);
    }
    this.data.list_services = list;
  }

  // =============== lich su phan phoi ================= //
  loadHistoryDistribution() {
    this.bodyDistribution = {
      serial: this.data.serial,
      page: this.pageIndexDistribution,
      page_size: this.pageSizeDistribution,
      owner: this.data.owner,
    };
    this.checkStampService.getStampHistory(this.bodyDistribution).subscribe(
      async (res) => {
        if (res.code === 1) {
          this.data_distribution = res.data.items;
          await this.data_distribution.map((item) => {
            const arr_keys = ["fromProvince", "fromDistrict", "fromAddress"];
            arr_keys.map((key) => {
              if (item[key] === null) {
                item[key] = "Không xác định";
              }
            });

            if (item.toAgency === null) {
              item.toAgency = "Không xác định";
              const list_province_Id = item.location.item.provinceIds;
              const list_province_name = [];
              this.cities.map((city) => {
                if (list_province_Id.includes(city.id)) {
                  list_province_name.push(city.value);
                }
              });
              item.to_list_provinceName = "Không xác định";
              item.to_list_districtName = "Không xác định";
              item.to_list_address = "Không xác định";
              if (item.to_list_provinceName.length > 0) {
                item.to_list_provinceName = list_province_name.toString();
              }
              if (list_province_Id.length === 1) {
                const list_district_Id = item.location.item.districtIds;
                const list_district_name = [];
                this.getDistrictMap(list_province_Id[0]).then((districts) => {
                  if (districts.error === false) {
                    const data_districts = districts.data.districts;
                    data_districts.map((one_district) => {
                      if (list_district_Id.includes(one_district.id)) {
                        list_district_name.push(one_district.name);
                      }
                    });
                    if (list_district_name.length > 0) {
                      item.to_list_districtName = list_district_name.toString();
                    }
                  }
                });
                if (list_district_Id.length === 1) {
                  item.to_list_address = item.location.item.address[0];
                }
              }
              return;
            }
            const keys = ["toProvince", "toDistrict", "toAddress"];
            keys.map((key) => {
              if (item[key] === null) {
                item[key] = "Không xác định";
              }
            });
          });
          this.total_distribution = res.data.totalElement;
          if (res.data.totalElement && this.load_map_distrivution === true) {
            this.getAllHistoryDistribution();
          }
          return;
        }
        this.data_distribution = [];
        this.total_distribution = 0;
      },
      (error) => {
        this.data_distribution = [];
        this.total_distribution = 0;
      }
    );
  }

  prePageHistoryDistribution() {
    if (this.pageIndexDistribution > 1) {
      this.pageIndexDistribution = this.pageIndexDistribution - 1;
      this.load_map_distrivution = false;
      this.loadHistoryDistribution();
    }
  }

  inputPageHistoryDistributionChange(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexDistribution) {
      this.pageIndexDistribution = page;
      this.load_map_distrivution = false;
      this.loadHistoryDistribution();
    }
  }

  lastPageHistoryDistribution() {
    if (
      this.pageIndexDistribution * this.pageSizeDistribution <
      this.total_distribution
    ) {
      this.pageIndexDistribution = this.pageIndexDistribution + 1;
      this.load_map_distrivution = false;
      this.loadHistoryDistribution();
    }
  }

  // =============== end lich su phan phoi ================= //

  // =============== lich su quet =================== //

  loadHistoryScan() {
    const body = {
      serial: this.data.serial,
      owner: this.data.owner,
      page: this.pageIndexScan,
      pageSize: this.pageSizeScan,
    };
    this.checkStampService.getHistoryScanStampProduct(body).subscribe(
      (res) => {
        if (res.code === 1) {
          this.data_scan = res.data.items;
          this.total_scan = res.data.totalElement;
          return;
        }
        this.data_scan = [];
        this.total_scan = 0;
      },
      (error) => {
        this.data_scan = [];
        this.total_scan = 0;
      }
    );
  }

  prePageHistoryScan() {
    if (this.pageIndexScan > 1) {
      this.pageIndexScan = this.pageIndexScan - 1;
      this.loadHistoryScan();
    }
  }

  inputPageHistoryScanChange(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexScan) {
      this.pageIndexScan = page;
      this.loadHistoryScan();
    }
  }

  lastPageHistoryScan() {
    if (this.pageIndexScan * this.pageSizeScan < this.total_scan) {
      this.pageIndexScan = this.pageIndexScan + 1;
      this.loadHistoryScan();
    }
  }

  // =============== end lich su quet ================ //

  onMouseOver(infoWindow, gm) {
    if (gm.lastOpen != null) {
      gm.lastOpen.close();
    }

    gm.lastOpen = infoWindow;

    infoWindow.open();
  }

  onMouseOut(infoWindow, gm) {
    infoWindow.close();
  }

  moveToMap() {
    $("html, body").animate({ scrollTop: 1300 }, 500);
  }

  changeTab(event) {
    this.activeTab = event;
    this.resetModalWarning();
  }

  openModalBlock() {
    this.note_block = undefined;
    this.disable_block = false;
    this.blockModal.show();
  }

  submitModalBlock() {
    if (!this.note_block) {
      this.toastr.error("Chưa nhập lý do khóa", "Có lỗi xảy ra");
      return;
    }
    const batch_id = this.data.batchId;
    let serial = this.data.serial;
    serial = serial.split("-");
    if (serial && serial.length === 2) {
      this.disable_block = true;
      let id = serial[1];
      id = id.split("");
      let index = 0;
      for (let i = 0; i < id.length; i++) {
        // tslint:disable-next-line:radix
        if (parseInt(id[i]) !== 0) {
          index = id.indexOf(id[i]);
          break;
        }
      }
      const id_start = serial[1].slice(index);
      const body = {
        batch_id: batch_id,
        id_start: id_start,
        id_end: id_start,
        note: this.note_block.trim(),
        status: 1,
      };
      this.batchService.restoreStamp(body).subscribe(
        (res) => {
          this.disable_block = false;
          if (res.error === false) {
            this.toastr.success("Khóa tem thành công", "Thông báo");
            this.blockModal.hide();
            return;
          }
          this.toastr.success(res.message, "Khóa tem thất bại");
        },
        (error) => {
          this.disable_block = false;
          this.toastr.error(error.message, "Khóa tem thất bại");
        }
      );
    }
  }

  getTotalWarning(agencyId?: string) {
    return this.checkStampService.getTotalWarning(agencyId).toPromise();
  }

  getDetilAgency(id?: string) {
    return this.agencyService.getDetail(id).toPromise();
  }

  submitModalWarning() {
    const val = $("#agency").val();
    if (this.activeTab === 1) {
      if (!val) {
        this.valid_agency = true;
        return;
      }
      const body = {
        type: 0,
        // tslint:disable-next-line:radix
        provinceWarningId: parseInt(this.agency_detail.provinceId),
        // tslint:disable-next-line:radix
        districtWarningId: parseInt(this.agency_detail.districtId),
        wardWarningId: null,
        addressWarning: this.agency_detail.address,
        note: this.note_warning,
        // tslint:disable-next-line:radix
        agencyWarningId: parseInt(val),
        stampCode: this.data.serial,
        bundleType: 0,
      };
      this.body = body;
    }
    if (this.activeTab === 2) {
      const provinceId = $("#citiesProduct").val();
      const districtId = $("#districtProduct").val();
      if (!provinceId) {
        this.validProvinceId = true;
      }
      if (!districtId) {
        this.validDistrict = true;
      }
      if (!provinceId || !districtId) {
        return;
      }
      const body = {
        type: 1,
        // tslint:disable-next-line:radix
        provinceWarningId: parseInt(provinceId),
        // tslint:disable-next-line:radix
        districtWarningId: parseInt(districtId),
        wardWarningId: null,
        addressWarning: this.address,
        note: this.note_warning,
        bundleId: this.data.bundleId,
        // tslint:disable-next-line:radix
        agencyWarningId: null,
        bundleItemId: this.data.bundleItemId,
        stampCode: this.data.serial,
      };
      this.body = body;
    }
    this.disable_warning = true;
    this.checkStampService.createWarning(this.body).subscribe(
      (res) => {
        this.disable_warning = false;
        if (res.code === 1) {
          this.toastr.success("Tạo mới cảnh báo thành công", "Thành công");
          this.checkWarning.hide();
          this.loadListWarning();
          this.after_create_warning = true;
          this.getAllWarningMarket();
          this.resetModalWarning();
          return;
        }
        this.toastr.error(res.message, "Tạo mới cảnh báo thất bại");
      },
      (error) => {
        this.disable_warning = false;
        this.toastr.error(error.message, "Tạo mới cảnh báo thất bại");
      }
    );
  }

  showModalWarning() {
    this.activeTab = 1;
    this.resetModalWarning();
    this.checkWarning.show();
  }

  closeModalWarning() {
    this.resetModalWarning();
    this.activeTab = 1;
    this.checkWarning.hide();
  }

  resetModalWarning() {
    this.valid_agency = false;
    this.warning_count = 0;
    this.warning_count = 0;
    this.note_warning = undefined;
    this.validDistrict = false;
    this.validProvinceId = false;
    this.address = undefined;
    $("#agency").val(null).trigger("change");
    $("#citiesProduct").val(null).trigger("change");
    $("#districtProduct").val(null).trigger("change");
  }

  getFromArea() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  getDistrict(id: number) {
    const query = {
      city_id: id,
    };
    this.addressService.getDistrict(query).subscribe(
      (res) => {
        if (res.status === 200) {
          const citiesList = [];
          const items = res.data.districts;
          items.map((item) => {
            citiesList.push({
              label: item.name,
              id: item.id,
            });
          });
          this.districts = citiesList;

          return;
        }
        this.districts = [];
      },
      (error) => {
        this.districts = [];
      }
    );
  }

  // ================ trả hàng ========================= //
  openModalReturn() {
    this.note_return = "";
    this.retutn.show();
  }

  closeModalReturn() {
    this.retutn.hide();
  }

  noteReturnChange() {
    this.valid_note_return = false;
  }

  submitModalReturn() {
    this.valid_note_return = false;
    if (!this.note_return) {
      this.valid_note_return = true;
      return;
    }
    let serial = this.data.serial;
    serial = serial.split("-");
    if (serial && serial.length === 2) {
      this.disable_block = true;
      let id = serial[1];
      id = id.split("");
      let index = 0;
      for (let i = 0; i < id.length; i++) {
        // tslint:disable-next-line:radix
        if (parseInt(id[i]) !== 0) {
          index = id.indexOf(id[i]);
          break;
        }
      }
      const id_start = serial[1].slice(index);
      const body = {
        listData: [
          {
            type: 0,
            prefix: this.data.prefix,
            idStart: id_start,
            idEnd: id_start,
            note: this.note_return,
          },
        ],
      };
      this.checkStampService.createReturnStamp(body).subscribe(
        (res) => {
          if (res.code === 1) {
            this.toastr.success(
              "Tạo mới yêu cầu trả tem thành công" +
                `<div>Thành công: <b>${res.data.success}</b>, Thất bại: <b>${res.data.fail}</b></div>`,
              "Thành công",
              {
                timeOut: 3000,
                positionClass: "toast-top-right",
                enableHtml: true,
              }
            );
            this.closeModalReturn();
            return;
          }
          this.toastr.error(res.message, "Thất bại");
        },
        (error) => {
          this.toastr.error(error.message, "Thất bại");
        }
      );
    }
  }

  // ================ end trả hàng ===================== //

  // ================ phan phoi =================== //

  changeDistribution() {
    this.isDistribution = true;
    this.isList = false;
    setTimeout(() => {
      this.boxStampDistribution.setData(
        this.data.serial,
        this.data.bundleType,
        true
      );
    }, 500);
  }

  hideComponentDistribuiton(event) {
    this.isDistribution = false;
    this.isList = true;
  }

  getAllHistoryDistribution() {
    const body = {
      page: 1,
      serial: this.data.serial,
      page_size: this.total_distribution,
      owner: this.data.owner,
    };
    this.data_map = [];
    this.checkStampService.getStampHistory(body).subscribe((res) => {
      if (res.code === 1) {
        const items = res.data.items;
        const data = [];
        for (let i = items.length - 1; i >= 0; i--) {
          data.push(items[i]);
        }
        this.getMapFromLatLng(data);
      }
    });
  }

  getMapFromLatLng(data?: any[]) {
    data.map(async (item, index) => {
      const type = [];
      if (item.userScanWarning) {
        type.push(0);
      }
      if (item.warning) {
        type.push(1);
      }
      let color;
      switch (item.transferType) {
        case 0: {
          color = "blue";
          break;
        }
        case 1: {
          color = "#f00";
          break;
        }
        case 2: {
          color = "#BDBDBD";
          break;
        }
      }
      const object = {
        origin: undefined,
        destination: undefined,
        renderOptions: undefined,
      };
      if (item.transferType === 1 || item.transferType === 2) {
        object.renderOptions = {
          polylineOptions: { strokeColor: `${color}`, strokeWeight: 5 },
        };
      }
      // tslint:disable-next-line:max-line-length
      const address_from =
        (item.fromAddress !== null ? item.fromAddress : "") +
        " " +
        (item.fromDistrict !== null ? item.fromDistrict : "") +
        " " +
        (item.fromProvince !== null ? item.fromProvince : "");
      const query_from = {
        input: address_from,
        api_key: "vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq",
      };
      await this.getPlaceId(query_from).then((place_id_from) => {
        if (place_id_from.status === "OK") {
          const place_id = place_id_from.predictions[0].place_id;
          this.getLatLon(place_id).then((latlon_from) => {
            if (latlon_from.status === "OK") {
              const obj_from = {
                lat: latlon_from.result.geometry.location.lat,
                lng: latlon_from.result.geometry.location.lng,
              };
              this.lng = latlon_from.result.geometry.location.lng;
              this.lat = latlon_from.result.geometry.location.lat;
              object.origin = obj_from;
            }
          });
        }
      });
      // get Lat lon theo dia chi
      if (
        item.toProvince !== null ||
        item.toDistrict !== null ||
        item.toAddress !== null
      ) {
        // tslint:disable-next-line:max-line-length
        const address_to =
          (item.toAddress !== null ? item.toAddress : "") +
          " " +
          (item.toDistrict !== null ? item.toDistrict : "") +
          " " +
          (item.toProvince !== null ? item.toProvince : "");
        const query_to = {
          input: address_to,
          api_key: "vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq",
        };
        this.getPlaceId(query_to).then((place_id_data) => {
          if (place_id_data.status === "OK") {
            const place_id = place_id_data.predictions[0].place_id;
            this.getLatLon(place_id).then((latlon_to_case_one_province) => {
              if (latlon_to_case_one_province.status === "OK") {
                const obj = {
                  lat: latlon_to_case_one_province.result.geometry.location.lat,
                  lng: latlon_to_case_one_province.result.geometry.location.lng,
                };
                const a = {
                  origin: object.origin,
                  destination: obj,
                  renderOptions: object.renderOptions,
                };
                this.data_map.push(a);
                const market = {
                  lat: latlon_to_case_one_province.result.geometry.location.lat,
                  lng: latlon_to_case_one_province.result.geometry.location.lng,
                  label: `${latlon_to_case_one_province.result.name},${latlon_to_case_one_province.result.formatted_address}`,
                  icon: {
                    url: undefined,
                    scaledSize: {
                      height: 30,
                      width: 30,
                    },
                  },
                  type: [],
                  agency: undefined,
                };
                market.agency =
                  item.toAgency !== null ? item.toAgency.trim() : "";
                if (type.length === 1) {
                  type.map((item_type) => {
                    // tslint:disable-next-line:radix
                    if (parseInt(item_type) === 0) {
                      market.icon.url =
                        "https://image.flaticon.com/icons/svg/1277/1277612.svg";
                      market.type = [0];
                    }
                    // tslint:disable-next-line:radix
                    if (parseInt(item_type) === 1) {
                      market.icon.url =
                        "https://image.flaticon.com/icons/svg/3325/3325026.svg";
                      market.type = [1];
                    }
                    this.data_map_warning.push(market);
                  });
                }
                if (type.length === 2) {
                  if (type.includes(0) && type.includes(1)) {
                    market.icon.url =
                      "https://image.flaticon.com/icons/svg/1277/1277612.svg";
                    market.type = [0, 1];
                  }
                  this.data_map_warning.push(market);
                }
              }
            });
          }
        });
        return;
      }
      // get lat lon theo id
      const locationTo = item.location.item;
      const provinces = locationTo.provinceIds;
      const arr = [];
      // case 1 tinh
      if (provinces.length === 1) {
        const provinceId = provinces[0];
        let provinceName = "";
        this.cities.map((city) => {
          if (city.id === provinceId) {
            provinceName = city.value;
          }
        });
        let district_list = [];
        await this.getDistrictMap(provinceId).then((district) => {
          if (district.error === false) {
            district_list = district.data.districts;
          }
        });
        let locationToConverted = [];
        const districts_to = locationTo.districtIds;
        if (districts_to.length > 0) {
          const districts_to_name = [];
          if (districts_to.length) {
            districts_to.map((d) => {
              district_list.map((di) => {
                if (di.id === d) {
                  districts_to_name.push(di.name);
                }
              });
            });
          }
          districts_to_name.map((i) => {
            const location = `${i} ${provinceName}`;
            locationToConverted.push(location);
          });
          if (locationToConverted.length === 1) {
            locationToConverted.map((l) => {
              locationToConverted = [];
              locationToConverted = [`${locationTo.address} ${l}`];
            });
          }
        }
        if (districts_to.length === 0) {
          const address$ = locationTo.address;
          if (address$.length > 0) {
            locationToConverted = [`${address$[0]} ${provinceName}`];
          } else {
            locationToConverted = [`${provinceName}`];
          }
        }
        // tslint:disable-next-line:no-shadowed-variable
        locationToConverted.map((l, index) => {
          arr.push(
            new Promise((resolve, reject) => {
              const query_to = {
                input: l,
                api_key: "vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq",
              };
              const get_placeId_to = this.getPlaceId(query_to);
              get_placeId_to.then((placeId) => {
                if (placeId.status === "OK") {
                  const place_id = placeId.predictions[0].place_id;
                  this.getLatLon(place_id).then((latlon) => {
                    if (latlon.status === "OK") {
                      const obj = {
                        lat: latlon.result.geometry.location.lat,
                        lng: latlon.result.geometry.location.lng,
                      };
                      const market = {
                        lat: latlon.result.geometry.location.lat,
                        lng: latlon.result.geometry.location.lng,
                        label: `${latlon.result.name},${latlon.result.formatted_address}`,
                        icon: {
                          url: undefined,
                          scaledSize: {
                            height: 30,
                            width: 30,
                          },
                        },
                        type: [],
                        agency: undefined,
                      };
                      if (type.length === 1) {
                        type.map((item_type) => {
                          // tslint:disable-next-line:radix
                          if (parseInt(item_type) === 0) {
                            market.icon.url =
                              "https://image.flaticon.com/icons/svg/1277/1277612.svg";
                            market.type = [0];
                          }
                          // tslint:disable-next-line:radix
                          if (parseInt(item_type) === 1) {
                            market.icon.url =
                              "https://image.flaticon.com/icons/svg/3325/3325026.svg";
                            market.type = [1];
                          }
                          this.data_map_warning.push(market);
                        });
                      }
                      if (type.length === 2) {
                        if (type.includes(0) && type.includes(1)) {
                          market.icon.url =
                            "https://image.flaticon.com/icons/svg/1277/1277612.svg";
                          market.type = [0, 1];
                        }
                        this.data_map_warning.push(market);
                      }
                      resolve(obj);
                    }
                  });
                }
              });
            })
          );
        });
        Promise.all(arr).then((data_finally) => {
          data_finally.map((one_data) => {
            const a = {
              origin: object.origin,
              destination: one_data,
              renderOptions: object.renderOptions,
            };
            this.data_map.push(a);
          });
        });
        return;
      }
      // case nhieu tinh
      const list_province_name = [];
      await provinces.map((pro) => {
        this.cities.map((ci) => {
          if (ci.id === pro) {
            list_province_name.push(ci.value);
          }
        });
      });
      list_province_name.map((pro_name) => {
        arr.push(
          new Promise((resolve, reject) => {
            const query_from_case_multiple_province = {
              input: pro_name,
              api_key: "vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq",
            };
            this.getPlaceId(query_from_case_multiple_province).then(
              (place_id_from) => {
                if (place_id_from.status === "OK") {
                  const place_id = place_id_from.predictions[0].place_id;
                  this.getLatLon(place_id).then((latlon) => {
                    if (latlon.status === "OK") {
                      const obj = {
                        lat: latlon.result.geometry.location.lat,
                        lng: latlon.result.geometry.location.lng,
                      };
                      const market = {
                        lat: latlon.result.geometry.location.lat,
                        lng: latlon.result.geometry.location.lng,
                        label: `${latlon.result.name},${latlon.result.formatted_address}`,
                        icon: {
                          url: undefined,
                          scaledSize: {
                            height: 30,
                            width: 30,
                          },
                        },
                        type: [],
                        agency: undefined,
                      };
                      if (type.length === 1) {
                        type.map((item_type) => {
                          // tslint:disable-next-line:radix
                          if (parseInt(item_type) === 0) {
                            market.icon.url =
                              "https://image.flaticon.com/icons/svg/1277/1277612.svg";
                            market.type = [0];
                          }
                          // tslint:disable-next-line:radix
                          if (parseInt(item_type) === 1) {
                            market.icon.url =
                              "https://image.flaticon.com/icons/svg/3325/3325026.svg";
                            market.type = [1];
                          }
                          this.data_map_warning.push(market);
                        });
                      }
                      if (type.length === 2) {
                        if (type.includes(0) && type.includes(1)) {
                          market.icon.url =
                            "https://image.flaticon.com/icons/svg/1277/1277612.svg";
                          market.type = [0, 1];
                        }
                        this.data_map_warning.push(market);
                      }
                      resolve(obj);
                    }
                  });
                }
              }
            );
          })
        );
      });
      Promise.all(arr).then((data_finally) => {
        data_finally.map((one_data) => {
          const a = {
            origin: object.origin,
            destination: one_data,
            renderOptions: object.renderOptions,
          };
          this.data_map.push(a);
        });
      });
    });
  }

  getAllWarningMarket() {
    this.warningInspection
      .getList({
        page: 1,
        page_size: !this.after_create_warning
          ? this.total_warning
          : this.total_warning + 1,
        serial: this.data.serial,
      })
      .subscribe((res) => {
        if (res.code === 1) {
          const items = res.data.items;
          const arr_promise = [];
          items.map((item, index) => {
            if (this.after_create_warning === true && index !== 0) {
              return;
            }
            arr_promise.push(
              new Promise((resolve, reject) => {
                // canh bao toi dai ly
                // tslint:disable-next-line:max-line-length
                const address =
                  (item.addressWarning !== null
                    ? item.addressWarning + " "
                    : "") +
                  (item.districtWarning !== null
                    ? item.districtWarning + " "
                    : "") +
                  (item.provinceWarning !== null ? item.provinceWarning : "");
                const query = {
                  input: address,
                  api_key: "vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq",
                };
                this.getPlaceId(query).then((place) => {
                  if (place.status === "OK") {
                    const place_id = place.predictions[0].place_id;
                    this.getLatLon(place_id).then(async (latlon) => {
                      if (latlon.status === "OK") {
                        const nameAgency =
                          item.agencyWarning !== null ? item.agencyWarning : "";
                        const market = {
                          lat: latlon.result.geometry.location.lat,
                          lng: latlon.result.geometry.location.lng,
                          // tslint:disable-next-line:max-line-length
                          label: `${latlon.result.name},${latlon.result.formatted_address}`,
                          icon: {
                            url:
                              "https://image.flaticon.com/icons/svg/196/196759.svg",
                            scaledSize: {
                              height: 30,
                              width: 30,
                            },
                          },
                          type: [2],
                          agency: nameAgency,
                        };
                        resolve(market);
                      }
                    });
                  }
                });
              })
            );
          });
          Promise.all(arr_promise).then((data_market) => {
            if (this.after_create_warning === false) {
              // loai bo cac điểm cảnh báo trùng nhau
              const data_market_finish = [];
              data_market.map(async (mar) => {
                if (data_market_finish.length === 0) {
                  data_market_finish.push(mar);
                  return;
                }
                let not_in = false;
                data_market_finish.map(async (i) => {
                  if (i.lat === mar.lat && i.lng === mar.lng) {
                    not_in = true;
                  }
                });
                if (!not_in) {
                  data_market_finish.push(mar);
                }
              });
              if (this.data_map_warning.length === 0) {
                data_market_finish.map((data$) => {
                  this.data_map_warning.push(data$);
                  return;
                });
              } else {
                data_market_finish.map(async (data$) => {
                  let not_in_data_warning = false;
                  this.data_map_warning.map(async (i_of_data) => {
                    if (
                      i_of_data.lat === data$.lat &&
                      i_of_data.lng === data$.lng
                    ) {
                      not_in_data_warning = true;
                    }
                  });
                  if (!not_in_data_warning) {
                    await this.data_map_warning.push(data$);
                  } else {
                    this.data_map_warning.map((item_duplicate) => {
                      if (
                        item_duplicate.lat === data$.lat &&
                        item_duplicate.lng === data$.lng &&
                        !item_duplicate.type.includes(2)
                      ) {
                        item_duplicate.type.push(2);
                        if (item_duplicate.agency !== data$.agency) {
                          item_duplicate.agency = `${item_duplicate.agency},${data$.agency}`;
                        }
                      }
                    });
                  }
                });
              }
              this.data_map_warning.map((item_convert) => {
                let label = "";
                const typeOfMarket = item_convert.type;
                if (typeOfMarket.length === 1) {
                  if (typeOfMarket.includes(0)) {
                    label = "Địa điểm bị cảnh báo từ người dùng";
                  }
                  if (typeOfMarket.includes(1)) {
                    label = "Địa điểm bị cảnh báo tự động";
                  }
                  if (typeOfMarket.includes(2)) {
                    label = "Địa điểm bị cảnh báo từ kiểm tra thị trường";
                  }
                }
                if (typeOfMarket.length === 2) {
                  if (typeOfMarket.includes(0) && typeOfMarket.includes(1)) {
                    label = "Địa điểm bị cảnh báo từ người dùng và tự động";
                  }
                  if (typeOfMarket.includes(0) && typeOfMarket.includes(2)) {
                    label =
                      "Địa điểm bị cảnh báo từ người dùng và kiểm tra thị trường";
                  }
                  if (typeOfMarket.includes(1) && typeOfMarket.includes(2)) {
                    label =
                      "Địa điểm bị cảnh báo tự động và kiểm tra thị trường";
                  }
                }
                if (typeOfMarket.length === 3) {
                  label =
                    "Địa điểm bị cảnh báo từ người dùng,tự động và kiểm tra thị trường";
                }
                if (item_convert.agency) {
                  const to_agency = `${item_convert.agency}.Địa chỉ:`;
                  item_convert.label = `${label}:${to_agency}${item_convert.label} `;
                } else {
                  item_convert.label = `${label}.Địa chỉ:${item_convert.label} `;
                }
              });
              return;
            }
            if (this.after_create_warning === true) {
              data_market.map((one_data_market) => {
                let label$ = "";
                if (one_data_market.agency) {
                  label$ = `Địa điểm bị cảnh báo từ kiểm tra thị trường:${one_data_market.agency}.Địa chỉ:${one_data_market.label}`;
                } else {
                  label$ = `Địa điểm bị cảnh báo từ kiểm tra thị trường.Địa chỉ:${one_data_market.label}`;
                }
                one_data_market.label = label$;
                this.data_map_warning.push(one_data_market);
              });
            }
          });
          return;
        }
      });
  }

  getPlaceId(query?: any) {
    return this.checkStampService.getPalceId(query).toPromise();
  }

  getLatLon(place_id?: string) {
    const query = {
      placeid: place_id,
      api_key: "vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq",
    };
    return this.checkStampService.getLatLon(query).toPromise();
  }

  // =============== ds cnah bao tu kiem tra thi truong =============== //
  loadListWarning() {
    this.queryWarning = {
      serial: this.data.serial,
      agencyId: "",
      provinceId: "",
      districtId: "",
      wardId: "",
      from: "",
      to: "",
      page: this.pageIndexWarning,
      page_size: this.pageSizeWarning,
    };
    this.checkStampService.getWarningMarket(this.queryWarning).subscribe(
      (res) => {
        if (res.code === 1) {
          this.data_warning = res.data.items;
          this.total_warning = res.data.totalElement;
          return;
        }
        this.data_warning = [];
        this.total_warning = 0;
      },
      (error) => {
        this.data_warning = [];
        this.total_warning = 0;
      }
    );
  }

  prePageWarning() {
    if (this.pageIndexWarning > 1) {
      this.pageIndexWarning = this.pageIndexWarning - 1;
      this.loadListWarning();
    }
  }

  inputPageWarningChange(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexWarning) {
      this.pageIndexWarning = page;
      this.loadListWarning();
    }
  }

  lastPageWarning() {
    if (this.pageIndexWarning * this.pageSizeWarning < this.total_warning) {
      this.pageIndexWarning = this.pageIndexWarning + 1;
      this.loadListWarning();
    }
  }

  // =============== end ds canh bao ====================== //
  async getDistrictMap(id: number) {
    const query = {
      city_id: id,
    };
    return await this.addressService.getDistrict(query).toPromise();
  }

  formatSerial(number, prefix: string = "") {
    let format_serial: string;
    let prefix2 = prefix ? prefix + "-" : "";
    number = number.toString();
    if (number.length > 6) {
      format_serial = prefix2 + number;
    } else {
      let pad = "000000";
      format_serial = prefix2 + pad.substring(0, 6 - number.length) + number;
    }
    return format_serial;
  }

  toggleNote() {
    $("#note-block").toggleClass("hide-note");
    if ($("#note-block").hasClass("hide-note")) {
      $("#agm-map-ic").css({ height: "calc(100vh - 173px - 50px + 123px)" });
      $("#icon-expand").css({ transform: "rotate(180deg)" });
    } else {
      $("#agm-map-ic").css({ height: "calc(100vh - 173px - 50px)" });
      $("#icon-expand").css({ transform: "unset" });
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/stamp_list_mb/stamp-product-mb/stamp-product-mb.component.ts